import { Button } from '@hub/shared'
import { SqCallout } from '@squidit/react-css'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import './box-categories.component.scoped.scss'

interface Props {
  onSetOpenEditCategories: (open: boolean) => void
}

export default ({ onSetOpenEditCategories }: Props) => {
  const [t] = useTranslation('cardSocialNetwork')

  const handleSetOpenEditCategories = useCallback(
    (open: boolean) => {
      if (onSetOpenEditCategories && typeof onSetOpenEditCategories === 'function') {
        onSetOpenEditCategories(open)
      }
    },
    [onSetOpenEditCategories]
  )

  return (
    <SqCallout title={t('withoutCategories')} smallIconStyle icon="fa-solid fa-diamond-exclamation" style={{ width: '100%' }}>
      <div className="content-edit-categories">
        <p className="description pt-3">{t('descriptionWithoutCategories')}</p>
        <Button width="100%" size="sm" onClick={() => handleSetOpenEditCategories(true)}>
          {t('configureCategories')}
        </Button>
      </div>
    </SqCallout>
  )
}
